// Configuration légale centralisée de l'écosystème PROGÈRE.
// Source unique de vérité — ne jamais réécrire ces informations en dur ailleurs.
// Les champs sensibles proviennent de variables d'environnement (REACT_APP_*).
// Ne JAMAIS inventer un NEQ, une adresse, un courriel ou un nom de responsable :
// les laisser vides tant qu'ils ne sont pas configurés et vérifiés.
export const PROGERE_LEGAL = {
  ecosystemName: "PROGÈRE",
  legalOperatorName: "Groupe MJR Construction inc.",
  displayOperatorName: "Groupe MJR Construction Inc.",
  neq: process.env.REACT_APP_PROGERE_NEQ || "",
  businessNumber: process.env.REACT_APP_PROGERE_BUSINESS_NUMBER || "",
  address: process.env.REACT_APP_PROGERE_LEGAL_ADDRESS || "",
  city: process.env.REACT_APP_PROGERE_LEGAL_CITY || "",
  province: "Québec",
  country: "Canada",
  postalCode: process.env.REACT_APP_PROGERE_POSTAL_CODE || "",
  supportEmail: process.env.REACT_APP_PROGERE_SUPPORT_EMAIL || "",
  privacyEmail: process.env.REACT_APP_PROGERE_PRIVACY_EMAIL || "",
  legalEmail: process.env.REACT_APP_PROGERE_LEGAL_EMAIL || "",
  billingEmail: process.env.REACT_APP_PROGERE_BILLING_EMAIL || "",
  privacyOfficerName: process.env.REACT_APP_PRIVACY_OFFICER_NAME || "",
  privacyOfficerTitle:
    process.env.REACT_APP_PRIVACY_OFFICER_TITLE ||
    "Responsable de la protection des renseignements personnels",
  effectiveDate: process.env.REACT_APP_LEGAL_EFFECTIVE_DATE || "2026-01-01",
  jurisdiction: "Québec, Canada",
  website: "https://progere.ca",
  copyrightStartYear: 2026,
};

// Vrai si toutes les coordonnées légales obligatoires sont configurées.
export const isLegalConfigComplete = () =>
  Boolean(
    PROGERE_LEGAL.legalOperatorName &&
      PROGERE_LEGAL.neq &&
      PROGERE_LEGAL.address &&
      PROGERE_LEGAL.privacyEmail &&
      PROGERE_LEGAL.privacyOfficerName
  );
